import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsEbay() {
  return (
    <IntegrationDocTemplate
      title="eBay"
      category="Marketplace"
      status="live"
      summary="eBay Sell APIs — Fulfillment (orders, shipping, refunds) + Inventory (items get/put). OAuth 2.0 user access tokens with refresh. No EDI required."
      prerequisites={[
        'eBay seller account in good standing.',
        'eBay developer app — register at developer.ebay.com.',
        'User access token obtained via OAuth consent (we drive this).',
      ]}
      connectSteps={[
        'Text us "eBay" with your phone number.',
        'Complete eBay OAuth in the popup; we capture refresh token.',
        'First sync: last 30 days of orders + active inventory items.',
        'Optional: enable auto-fulfillment routing through Commerce Index inventory + 3PL stack.',
      ]}
      syncedData={[
        { type: 'Orders', detail: 'get_orders with filter; full line items, shipping address, payment status' },
        { type: 'Shipping Fulfillment', detail: 'create_shipping_fulfillment with tracking number + carrier' },
        { type: 'Refunds', detail: 'issue_refund with reason codes' },
        { type: 'Inventory Items', detail: 'get/create/replace items via Inventory API' },
      ]}
      agents={[
        { id: 'ebay_listing_agent', name: 'ebay_listing_agent', role: 'Listing creation + Trading API orchestration' },
        { id: 'head_ecommerce', name: 'head_ecommerce', role: 'Channel routing director' },
      ]}
      troubleshooting={[
        { question: 'OAuth token expires mid-sync', answer: 'Refresh tokens last 18 months. Our client handles refresh automatically; check sync_log for OAuth refresh errors.' },
        { question: 'Apparel listings rejected (2026 update)', answer: 'eBay now blocks non-standard size info for Apparel & Footwear (July 2026). Use standard size taxonomy in listing attributes.' },
      ]}
      supportLink="/contact"
    />
  );
}
